import { WebpackRemoteContainer, WebpackSharedScopesOptions } from './types'
import environment from '../../config'
import { MfeContainer } from '../../features/mfe/types'
import { ensureSharedScopeAreActive } from './shared'

const getContainer = (containerName: MfeContainer): WebpackRemoteContainer | undefined =>
  (window as unknown as { [key: string]: WebpackRemoteContainer | undefined })[containerName]

const loadContainer = (containerName: MfeContainer): Promise<void> =>
  new Promise<void>((resolve, reject) => {
    const element = document.createElement('script')

    const remoteSource = environment.remotes[containerName]
    const remoteSourceWithCacheBusting = remoteSource + `?t=${new Date().getTime()}`

    element.src = remoteSourceWithCacheBusting
    element.type = 'text/javascript'
    element.async = true

    element.onload = () => {
      element.parentElement?.removeChild(element)
      resolve()
    }

    element.onerror = (err) => {
      element.parentElement?.removeChild(element)
      reject(
        err instanceof Event
          ? `Could not connect to remote container at '${(err.target as HTMLScriptElement).src}'.`
          : err,
      )
    }

    document.head.appendChild(element)
  })

const isContainerLoaded = (containerName: MfeContainer): boolean =>
  getContainer(containerName) !== undefined

export const ensureContainerIsActive = async (
  containerName: MfeContainer,
): Promise<WebpackRemoteContainer> => {
  const sharedScopes = await ensureSharedScopeAreActive()

  if (!isContainerLoaded(containerName)) await loadContainer(containerName)

  const container = getContainer(containerName) as WebpackRemoteContainer

  await container.init(sharedScopes[WebpackSharedScopesOptions.Default])

  return container
}
